<h1 mat-dialog-title>Send a Push Notification</h1>
<div mat-dialog-content>
  <p>Type Your Message :</p>
  <form [formGroup]="notifyForm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <mat-label>Title</mat-label>
            <input type="text" class="form-control" formControlName="title" placeholder="Message Title">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <mat-label>Content</mat-label>
              <textarea type="textarea" rows="8" class="form-control" formControlName="content"
              placeholder="Type a message here."></textarea>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <mat-label>URL</mat-label>
              <input type="text" class="form-control" formControlName="openURL"
                placeholder="Url To Open when click on message">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group">
              <div class="col-sm-offset-2 col-sm-8">
                <button type="button" class="btn btn-sm btn-primary" (click)="addActionButtonClick()">Add_Action
                </button>
              </div>
            </div>
            <div class="card bg " style="border: #616161; border-style: solid; border-width: thin">
              <div class="card-body">
                <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
                  @for (action of actions?.controls; track action; let i = $index) {
                    <div formArrayName="actions"
                      cdkDrag>
                      <div [formGroupName]="i.toString()">
                        <mat-accordion>
                          <mat-expansion-panel>
                            <mat-expansion-panel-header>
                              <!--                                                <mat-panel-title *ngIf="actions[i]">-->
                            <!--                                                    <b>{{_report.actions[i].name}}</b>-->
                          <!--                                                </mat-panel-title>-->
                          @if (actions[i] === undefined) {
                            <mat-panel-title>
                              <b>{{action.get('title').value}}</b>
                            </mat-panel-title>
                          }
                          <mat-panel-description>
                            Edit Action
                          </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div class="card">
                          <div class="card-header card-header-tabs card-header-info">
                            @if (actions.length>0) {
                              <div class="col-sm-12">
                                <button mat-mini-fab color="warn" class="pull-right"
                                  aria-label="Delete Action"
                                  title="Delete Action"
                                  (click)="removeActionButtonClick(i)">
                                  <mat-icon>close</mat-icon>
                                </button>
                              </div>
                            }
                          </div>
                          <div class="card-body">
                            <div class="row">
                              <div class="col-md-4">
                                <div class="form-group">
                                <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
                                <!--                                      <mat-form-field class="example-full-width">-->
                                <label>Title</label>
                                <input [id]="'title'+i"  type="text"
                                  class="form-control"
                                  formControlName="title">
                                  <!--                                                                <mat-error-->
                                  <!--                                                                        *ngFor="let validation of report_validation_messages.label">-->
                                  <!--                                                                    <mat-error class="error-message"-->
                                  <!--                                                                               *ngIf="inputField.get('label').hasError(validation.type) && (inputField.get('label').dirty || inputField.get('label').touched)">-->
                                  <!--                                                                        {{validation.message}}-->
                                <!--                                                                    </mat-error>-->
                              <!--                                                                </mat-error>-->
                            <!--                                      </mat-form-field>-->
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Action</label>
                            <input [id]="'action'+i" type="text"
                              class="form-control"
                              formControlName="action">
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Icon</label>
                              <input [id]="'icon'+i" type="text"
                                class="form-control"
                                formControlName="icon">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                  <mat-divider style="margin-bottom: 30px" class="bg-brand-info"></mat-divider>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
@if (showMsg) {
  <div class="alert fade show rounded" [className]="isErr? 'alert-danger' : 'alert-success'" role="alert"
    >
    <button type="button" class="close" data-dismiss="alert">&times;</button>
    {{message$ | async}}
  </div>
}
</div>
<div mat-dialog-actions class="pull-right">
  <div>
    <button mat-button class="btn btn-fill btn-warning" (click)="onCancelClick()">Cancel</button>
    <button mat-button class="btn btn-fill btn-success" (click)="onSendClick()" cdkFocusInitial>Send</button>
  </div>
</div>
